// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
import { isWeiXin } from '@/common/ts/common';
// 活动api baseurl
const urlPrefix = '/vote/2021project/q1/2021classroom/controller.php?enews=';

const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getVoteList = (type: number, page: number, keyword?: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      workType: type,
      page,
      search: keyword,
    },
  });
};
const getDetail = (id: any) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};
const share = (context: any) => {
  context.$appShareInfo({
    title: '第二课堂  助力成长',
    url: location.href,
    subtitle:
      '“重庆2021第二课堂文化节”之“教育培训机构/精品课程优选榜20强”推选投票中',
    classId: -1,
    id: -1,
    image:
      'https://image2.cqcb.com/d/file/topics/activity/2021-01-27/RRTjm86p-1611728907038.png',
    type: 3,
  });
  // 微信分享
  if (isWeiXin()) {
    context.$wxShareInfo({
      title: '第二课堂  助力成长',
      subtitle:
        '“重庆2021第二课堂文化节”之“教育培训机构/精品课程优选榜20强”推选投票中',
      image:
        'https://image2.cqcb.com/d/file/topics/activity/2021-01-27/RRTjm86p-1611728907038.png',
    });
  }
};
export { getBaseInfo, share, getRule, getVoteList, getDetail };
